import React from 'react'
import { ShoppingCart } from 'lucide-react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'

export const PointOfSales: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Point of Sales</h1>
        <p className="text-gray-600 dark:text-gray-400 mt-2">POS system for retail sales and transactions</p>
      </div>
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <ShoppingCart className="w-5 h-5" />POS Terminal
          </CardTitle>
          <CardDescription>Point of sale system and transaction processing</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="text-center py-12">
            <ShoppingCart className="w-12 h-12 text-gray-400 mx-auto mb-4" />
            <h3 className="text-lg font-medium mb-2">POS System</h3>
            <p className="text-gray-600 dark:text-gray-400 mb-4">Integrated sales and payment processing</p>
            <Button variant="outline">Open Terminal</Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
